import Vue from 'vue';
import Snotify, { SnotifyPosition } from 'vue-snotify';

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 1500,
    showProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    bodyMaxLength: 200,
  },
};

Vue.use(Snotify, options);
